import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './home/home.component';
import { InfoComponent } from './info/info.component';
import { SimulacionComponent } from './simulacion/simulacion.component';
import { SimulacionPublicaComponent } from './simulacion-publica/simulacion-publica.component';
import { RegistroUserComponent } from './registro-user/registro-user.component';
import { CuentasBancariasTuboComponent } from './cuentas-bancarias-tubo/cuentas-bancarias-tubo.component';
import { FichaInversionistaComponent } from './ficha-inversionista/ficha-inversionista.component';
import { FichaInversionistaCliente } from './ficha-inversionista-cliente/ficha-inversionista-cliente';

export const routes: Routes = [
    { path: '', redirectTo: "login", pathMatch: 'full' },
    { path: 'login', component: LoginComponent},
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'recover-password/:id', component: RecoverPasswordComponent },
    { path: 'simulacion', component: SimulacionPublicaComponent},
    { path: 'registro/:id', component: RegistroUserComponent},
    { path: 'ficha-inversion', component: FichaInversionistaCliente},
    { path: 'home', component: LayoutComponent,
        children: [
          { path: '', component: HomeComponent},
          { path: 'inicio', component: HomeComponent},
          { path: 'info/:id', component: InfoComponent},
          { path: 'info', component: InfoComponent},
          { path: 'ficha-inversionista', component: FichaInversionistaComponent},
          { path: 'cuentas-bancarias', component: CuentasBancariasTuboComponent},
          { path: 'simulacion', component: SimulacionComponent},
        ],
    },
    

];
